import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { colorTagsSearchScrollSet } from '../../../../store/actions/colorTagsSearchScrollSet';
import { getColorTagsSearchScroll } from '../../../../store/selectors/getColorTagsSearchScroll';
import { COLOR_TAGS_SEARCH_SCROLL_TIMEOUT } from '../../components/constants';

export const onOpen = (): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_COLOR_TAGS_CLICKED));
        if (getColorTagsSearchScroll(getState())) {
            setTimeout(() => {
                dispatch(colorTagsSearchScrollSet());
            }, COLOR_TAGS_SEARCH_SCROLL_TIMEOUT + 200);
        }
    }
}
